import { withUser, AuthAction } from "next-firebase-auth";
import "firebase/compat/firestore";

function LayoutRegister({children}) {
return(children)
}

export default withUser()(LayoutRegister);
